<section #sectionRoot class="border border-gray-200 rounded-xl shadow-sm">
    <!-- Header -->
    <div #mainHeader
        class="flex items-center justify-between px-3 py-3 cursor-pointer select-none rounded-xl hover:bg-neutral-100"
        role="button" tabindex="0" [attr.aria-expanded]="isOpen" (click)="toggle()" (keydown)="onHeaderKeydown($event)">
        <!-- Left side -->
        <div class="flex items-center gap-3">
            <!-- Open/close arrow -->
            <app-collapse-arrow [isOpen]="isOpen"></app-collapse-arrow>

            <!-- Title icon-->
            <img *ngIf="titleIcon" [src]="titleIcon" alt="" class="h-6 w-6 shrink-0" />

            <!-- Title text -->
            <span class="font-bold text-lg text-black">
                {{ title }}
            </span>
        </div>

        <!-- Right side -->
        <div class="flex items-center gap-2" (click)="$event.stopPropagation()" [ngClass]="showFloatingHeader
      ? 'fixed top-5 right-5 z-40'
      : ''">
            <!-- Example usage: <button header-actions> -->
            <ng-content select="[header-actions]"></ng-content>
        </div>
    </div>

    <div class="w-full h-[1px] bg-neutral-200" *ngIf="isOpen"></div>
    <!-- Content -->
    <div *ngIf="isOpen">
        <ng-content></ng-content>
    </div>
</section>